module.exports = __webpack_public_path__ + "img/listbg2.49f86a85.jpg";